// extracted by mini-css-extract-plugin
export default {"badgesList":"BadgeList_badgesList__J+Bgc","badgeListItem":"BadgeList_badgeListItem__CM+Ie","noBadgesText":"BadgeList_noBadgesText__1xr9x"};